import LocationService from "../../../services/masters/LocationService";
import serviceCalendar from "../../../services/calendar/CalendarService";
import serviceUser from "../../../services/user/UserService";
import {
    mapActions,
    mapState
} from "vuex";
import UserService from '../../../services/user/UserService';
const holidaysApi = require("colombia-holidays");

export default {
    props: ["providerId"],
    data() {
        // const today = new Date();
        return {
            statesData: [],
            citiesData: [],
            scheduleRangeData: [],
            state: null,
            city: null,
            branch: null,
            shippingDate: new Date(),
            scheduleRange: null,
            // address: this.$store.state.delivery.patient.address,
            nameNomenclature: null,
            address: "",
            numberOne: "",
            numberTwo: "",
            numberThree: "",
            shippingFee: null,
            observation: null,
            cityIsLoading: false,
            phone: this.$store.state.delivery.patient.phone,
            cellPhone: null,
            minDate: new Date(),
            notAllowedDays: [0],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            holidays: [],
            fechaAllowed: new Date(),
            dia: 0,
            mes: 0,
            year: 0,
            maxDate: new Date(),
            addressA: [{
                    name: "Anillo",
                    id: 1
                },
                {
                    name: "Autopista",
                    id: 2
                },
                {
                    name: "Avenida",
                    id: 3
                },
                {
                    name: "Avenida Calle",
                    id: 4
                },
                {
                    name: "Avenida Carrera",
                    id: 5
                },
                {
                    name: "Calle",
                    id: 6
                },
                {
                    name: "Carrera",
                    id: 7
                },
                {
                    name: "Circular",
                    id: 8
                },
                {
                    name: "Diagonal",
                    id: 9
                },
                {
                    name: "Transversal",
                    id: 10
                },
                {
                    name: "Zona",
                    id: 11
                }
            ],
            propertyTypes: [{
                    name: "-Tipo de inmueble-",
                    id: 1
                },
                {
                    name: "Urbanización",
                    id: 2
                },
                {
                    name: "Oficina",
                    id: 3
                },
                {
                    name: "Hotel",
                    id: 4
                },
                {
                    name: "Edificio",
                    id: 5
                },
                {
                    name: "Casa",
                    id: 6
                }
            ],
            blockOrInsides: [{
                    name: "-Bloque o interior-",
                    id: 1
                },
                {
                    name: "Piso",
                    id: 2
                },
                {
                    name: "Apartamento",
                    id: 3
                },
                {
                    name: "Habitación",
                    id: 4
                },
                {
                    name: "Bloque",
                    id: 5
                },
                {
                    name: "Zona",
                    id: 6
                },
                {
                    name: "Manzana",
                    id: 7
                }
            ],
            daysOfWeek: [],
            complementOne: null,
            complementTwo: null,
            blockOrInside: null,
            propertyType: null,
            forceShippingFee: [],
            isMinDateLoaded: false
        };
    },

    created() {
        this.getStates();
        this.getData();
        let today = new Date();
        let holidaysAux = holidaysApi.getColombiaHolidaysByYear(
            today.getFullYear()
        );
        for (let i = 0; i < holidaysAux.length; i++) {
            const holiday = holidaysAux[i];
            const input = holiday.holiday.split("-");
            let dateAux = new Date(input[0], input[1] - 1, input[2]);
            this.holidays.push(dateAux);
        }
        const orderType = this.provider == 1 ? "INTEGRATED" : "EXCLUSIVE";
        this.getForceShippingFee();
    },

    computed: {
        ...mapState("auth", ["user", "identification", "identificationType"]),

        ...mapState("delivery", {
            provider: "provider"
        }),

        isNextButtonDisable() {
            // this.shippingFee === null ||
            //         this.shippingFee === undefined ||
            //         !this.nameNomenclature ||
            //         !this.numberOne ||
            //         !this.numberTwo ||
            //         !this.numberThree ||
            //         !this.phone||
            //         !this.cellPhone||
            //         this.phone.length <= 6 ||
            //         this.cellPhone.length <= 9 ||
            //         this.cellPhone[0] != '3'||
            //         this.cellphoneEnable == false ||
            //         this.phoneEnable == false
            console.log("phone",this.phone)
            console.log("phone2",this.cellPhone)
            if((this.phone == "" || this.phone == undefined || this.phone == null) && (this.cellPhone == "" || this.cellPhone == undefined || this.cellPhone == null) ){
                return (
                    this.shippingFee === null ||
                    this.shippingFee === undefined ||
                    !this.nameNomenclature ||
                    !this.numberOne ||
                    !this.numberTwo ||
                    !this.numberThree ||
                    !this.phone||
                    !this.cellPhone||
                    ( this.phone.length <= 6 || this.phone.length == 8|| this.phone.length == 9 )||
                    this.cellPhone.length <= 9 ||
                    this.cellPhone[0] != '3' 
                );
                
            }else{
                console.log("pasooo else 1")
                if((this.phone != "" && this.phone != undefined && this.phone != null)|| (this.cellPhone == "" && this.cellPhone == undefined && this.cellPhone == null)){
                    console.log("pasooo if 1")
                    if(this.cellPhone.length <=9){
                        if(this.cellPhone == ""){
                            return(
                                this.shippingFee === null ||
                                this.shippingFee === undefined ||
                                !this.nameNomenclature ||
                                !this.numberOne ||
                                !this.numberTwo ||
                                !this.numberThree ||
                                ( this.phone.length <= 6 || this.phone.length == 8|| this.phone.length == 9 )
                                
                                
                            );
                        }else{
                            return(
                                this.shippingFee === null ||
                                this.shippingFee === undefined ||
                                !this.nameNomenclature ||
                                !this.numberOne ||
                                !this.numberTwo ||
                                !this.numberThree ||
                                this.cellPhone.length <= 9||
                                this.cellPhone[0] != '3' 
                                
                                
                            );
                        }
                         
                    }else{
                        console.log("else 2")
                        if(this.cellPhone[0] == '3' ){
                            console.log("if3")
                        
                            return(
                                this.shippingFee === null ||
                                this.shippingFee === undefined ||
                                !this.nameNomenclature ||
                                !this.numberOne ||
                                !this.numberTwo ||
                                !this.numberThree ||
                                ( this.phone.length <= 6 || this.phone.length == 8|| this.phone.length == 9 )
                                
                                
                            );
                        }else{
                            console.log("else3")
                            return(
                                this.shippingFee === null ||
                                this.shippingFee === undefined ||
                                !this.nameNomenclature ||
                                !this.numberOne ||
                                !this.numberTwo ||
                                !this.numberThree ||
                                this.cellPhone.length <= 9||
                                this.cellPhone[0] != '3' 
                                
                                
                            );
                            
                        }
                    
                    }
                    
                }else{
                    return(
                        this.shippingFee === null ||
                        this.shippingFee === undefined ||
                        !this.nameNomenclature ||
                        !this.numberOne ||
                        !this.numberTwo ||
                        !this.numberThree ||
                        this.cellPhone.length <= 9 ||
                        this.cellPhone[0] != '3' 
                        
                    );  
                }
              
                    
                
               
            }
           
        }
    },

    watch: {
        state() {
            this.getCities();
        },

        city() {
            this.getBranches();
        },

        scheduleRange() {
            this.shippingFee = this.scheduleRangeData
                .filter(scheduleRange => scheduleRange.id == this.scheduleRange)
                .map(scheduleRange => scheduleRange.shippingFee)[0];
        },
        cellPhone() {
            this.validateNumberCellphone()
        },
        phone() {
            this.validateNumberphone()
        },
    },

    methods: {

        async getData() {
            try {
                const body = {
                    identification: this.identification
                }
                const response = await UserService.getOne(body);
                this.cellPhone = response.data.cellPhone
                this.nameNomenclature = response.data.addressNomenclature
                this.numberOne = response.data.addressNumberOne
                this.numberTwo = response.data.addressNumberTwo
                this.numberThree = response.data.addressNumberThree
                this.complementOne = response.data.addressTypePropertyValue
                this.complementTwo = response.data.addressBlockOrInteriorValue
                this.blockOrInside = response.data.addressBlockOrInterior
                this.propertyType = response.data.addressTypeProperty
            } catch (error) {
                this.showToast('Error consultando la información de usuario', 'is-warning')
            }
        },

        async getForceShippingFee() {
            try {
                let response = await LocationService.forceShippingFeeAll();
                if (response.data.code === 'No data available') {
                    this.forceShippingFee = []
                } else {
                    this.forceShippingFee = response.data.map(data => data.idCity)
                }
            } catch (error) {
                console.log(error)
            }
        },

        onlyNumberAndLetters(e) {
            if (e.key.match(/[a-z0-9ñçáéíóú\s]/i) === null) {
                e.preventDefault();
            }
        },
        getDates(branch) {
            const formDate = this.formatDate(new Date());
            let data = {
                idProvider: this.provider,
                date: formDate,
                orderType: this.orderType
            };
            serviceCalendar
                .getAllowedDates(branch)
                .then(result => {
                    const Dates = result.data;
                    if (Dates.length < 10) {
                        for (let i = 0; i < Dates.length; i++) {
                            const aux = Dates[i];
                            const input = aux.split("-");
                            let dateAux = new Date(input[0], input[1] - 1, input[2]);
                            this.daysOfWeek.push(dateAux);
                        }
                    } else {
                        for (let i = 0; i < 10; i++) {
                            const aux = Dates[i];
                            const input = aux.split("-");
                            let dateAux = new Date(input[0], input[1] - 1, input[2]);
                            this.daysOfWeek.push(dateAux);
                        }
                    }
                    // this.daysOfWeek = result.data;
                    // let min = new Date(Dates[0].replace("-", "/"));
                    let splittedDate = Dates[0].split('-')
                    this.minDate = new Date(
                            parseInt(splittedDate[0]),
                            parseInt(splittedDate[1]) - 1,
                            parseInt(splittedDate[2])
                        )
                        // let max = new Date(Dates[7].replace("-", "/"));
                    if (Dates.length < 10) {
                        splittedDate = Dates[Dates.length - 1].split('-')
                    } else {
                        splittedDate = Dates[9].split('-')
                    }
                    this.maxDate = new Date(
                        parseInt(splittedDate[0]),
                        parseInt(splittedDate[1]) - 1,
                        parseInt(splittedDate[2])
                    );
                    this.shippingDate = this.minDate;
                    this.isMinDateLoaded = true
                })
                .catch(error => {
                    this.isMinDateLoaded = false
                    console.log(error);
                });
        },
        formatDate(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let zeroInDay = day.toString().length > 1 ? day : `0${day}`;
            let zeroInMonth = month.toString().length > 1 ? month : `0${month}`;
            return `${year}-${zeroInMonth}-${zeroInDay}`;
        },
        //Minimo de digitos para los campos de telefono
        minNum(e) {
            const key = e.key;
            if (/^\d{7}$/.test(key)) {} else {
                console.log(e);
                return e.preventDefault();
            }
        },

        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) {} else {
                return e.preventDefault();
            }
        },
        addressSanitizer(newVal) {
            let re = /[^A-Z0-9# -]/gi;
            this.$set(this, "address", newVal.replace(re, ""));
        },

        observationSanitizer(newVal) {
            let re = /[^A-Z0-9# -]/gi;
            this.$set(this, "observation", newVal.replace(re, ""));
        },

        phoneSanitizer(newVal) {
            let re = /[^0-9]/gi;
            this.$set(this, "phone", newVal.replace(re, ""));
        },

        cellphoneSanitizer(newVal) {
            let re = /[^0-9]/gi;
            this.$set(this, "cellPhone", newVal.replace(re, ""));
        },

        contains(arr, id) {
            return arr.some(e => e.id === id);
        },

        async getStates() {
            let type = "EXCLUSIVE";
            if (this.provider === 1) {
                type = "INTEGRATED";
            }

            const response = await LocationService.getStatesByCountry(1, type, this.provider)
            this.statesData = response.data;
            if (!this.contains(this.statesData, this.state)) this.state = "";
            if (this.statesData.length === 0) {
                const message = this.$t("app.components.delivery.no-coverage-area");
                this.$buefy.toast.open({
                    message,
                    type: "is-warning"
                });
            }
        },

        async getCities() {
            try {
                if (!this.state) return;
                this.cityIsLoading = true;
                let type = "EXCLUSIVE";
                if (this.provider === 1) {
                    type = "INTEGRATED";
                }
                const result = await LocationService.getCitiesByState(this.state, type, this.provider);

                this.citiesData = result.data;
                this.citiesData = this.citiesData.map(c => c.idCity)
                if (!this.contains(this.citiesData, this.city)) {
                    this.city = "";
                }
                if (!this.contains(this.branches, this.branch)) {
                    this.branch = "";
                }
                if (!this.contains(this.scheduleRanges, this.scheduleRange)) {
                    this.scheduleRange = "";
                }
                if (this.citiesData.length === 0) {
                    const message = this.$t("app.components.delivery.no-coverage-area");
                    this.$buefy.toast.open({
                        message,
                        type: "is-warning"
                    });
                }

                this.cityIsLoading = false;
            } catch (error) {
                this.cityIsLoading = false;
            }
        },

        async getBranches() {
            if (!this.city) return;

            if (this.city) {
                this.scheduleRange = "";
                this.scheduleRangeData = [];
            }

            let type = "EXCLUSIVE";
            if (this.provider === 1) {
                type = "INTEGRATED";
            }

            const response = await LocationService.getBranchesByCityAndProvider(
                this.city,
                this.provider,
                type
            );

            this.branches = response.data;

            if (this.branches && this.branches.length > 0) {
                this.branch = this.branches[0].id;
                this.scheduleRange = "";
                this.getScheduleRanges();
                this.getDates(this.branch);
            } else {
                const message = this.$t("app.components.delivery.no-coverage-area");
                this.$buefy.toast.open({
                    message,
                    type: "is-warning"
                });
            }
        },

        async getScheduleRanges() {
            if (!this.branch) return;
            const response = await LocationService.getScheduleRangesByBranch(
                this.branch
            );
            this.scheduleRangeData = response.data.filter(
                sr => sr.idBranchCity.idCity.id === this.city
            );
            this.scheduleRangeData.forEach(
                sr =>
                (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`)
            );
            if (!this.contains(this.scheduleRangeData, this.scheduleRange))
                this.scheduleRange = "";
        },
        validateNumberCellphone() {
            if (this.cellPhone[0] == '' || this.cellPhone[0] == undefined) {
                return
            }
            if (this.cellPhone[0] != '3') {
                this.$buefy.toast.open({
                    duration: 2000,
                    message: `El número celular debe empezar con el número 3`,
                    type: 'is-danger'
                })
            }

            if (this.cellPhone.length == 10) {
                this.cellphoneEnable = true;
                let count = 0;
                for (let i = 0; i < this.cellPhone.length; i++) {
                    let numberInitial = this.cellPhone[0]

                    if (numberInitial == this.cellPhone[i]) {
                        count += 1;
                    }
                }
                if (count == 10) {
                    this.cellphoneEnable = false;
                    this.$buefy.toast.open({
                        duration: 4000,
                        message: `Número inválido`,
                        type: 'is-danger'
                    })
                }
            }
        },
        validateNumberphone() {

            this.phone = this.phone.replace("(","").replace(")","");
            if(this.phone.length >= 10){
                var tres = this.phone.slice(0,3);
                var completo = this.phone.slice(3,11);
                 var final= "("+ tres +")"+completo;
                 this.phone = final;
                 console.log("phone",this.phone+"===>"+this.phone.length);
            if (this.phone[0] == '' || this.phone[0] == undefined) {
                return
            }
            if (this.phone.length >= 7) {
                this.phoneEnable = true;
                let count = 0;
                for (let i = 0; i < this.phone.length; i++) {
                    let numberInitial = this.phone[0]

                    if (numberInitial == this.phone[i]) {
                        count += 1;
                    }
                }
                if (count >= 7) {
                    this.phoneEnable = false;
                    this.$buefy.toast.open({
                        duration: 4000,
                        message: `Número inválido`,
                        type: 'is-danger'
                    })
                }
            }
        }
        },

        ...mapActions(
            'delivery', [
                'setShippingFee',
                'setShippingDate',
                'setState',
                'setCity',
                'setBranch',
                'setSchedule',
                'setScheduleName',
                'setAddress',
                'setObservations',
                'setPhone',
                'setCellPhone',
                'setnameNomenclature',
                'setnumberOne',
                'setnumberTwo',
                'setnumberThree',
                'setpropertyType',
                'setcomplementOne',
                'setblockOrInside',
                'setcomplementTwo'
            ]
        ),
        async nextPage() {
            if(this.phone != ""){
                if (this.nameNomenclature) this.setnameNomenclature(this.nameNomenclature)
                if (this.numberOne) this.setnumberOne(this.numberOne)
                if (this.numberTwo) this.setnumberTwo(this.numberTwo)
                if (this.numberThree) this.setnumberThree(this.numberThree)
                let address = this.nameNomenclature + ' ' + this.numberOne + ' # ' + this.numberTwo + ' - ' + this.numberThree
                this.address = address
                if (this.shippingDate) this.setShippingDate(this.shippingDate)
                if (this.state) this.setState(this.state)
                if (this.city) this.setCity(this.city)
                if (this.branch) this.setBranch(this.branch)
                if (this.scheduleRange) {
                    const scheduleRange = this.scheduleRangeData.find(scheduleRange => scheduleRange.id == this.scheduleRange)
                    this.setSchedule(scheduleRange.id)
                    this.setScheduleName(scheduleRange.range)
                }
    
                if (this.propertyType == "-Tipo de inmueble-") {
                    this.propertyType = '';
                }
                if (this.blockOrInside == "-Bloque o interior-") {
                    this.blockOrInside = '';
                }
    
                this.setpropertyType(this.propertyType)
                this.setcomplementOne(this.complementOne)
                this.setblockOrInside(this.blockOrInside)
                this.setcomplementTwo(this.complementTwo)
                if(this.phone != ""){
                    this.phone =this.phone.replace("(","").replace(")","")
                }
                if (this.address) this.setAddress(this.address)
                if (this.phone) this.setPhone(this.phone)
                if (this.cellPhone) this.setCellPhone(this.cellPhone)
                if (this.observation) this.setObservations(this.observation)
                let response = await serviceUser.prioritizedPatient(this.identification, this.identificationType)
                let patient = response.data
                if (patient && !patient.isPAC && !patient.hasPolicy && !this.contains(this.forceShippingFee, this.city)) {
                    this.shippingFee = 0
                }
                this.setShippingFee(this.shippingFee)
                this.$emit('nextStep')
                
            }else if(this.cellPhone != ""){
                if (this.cellPhone[0] != '3') {
                    this.$buefy.toast.open({
                        duration: 2000,
                        message: `El número celular debe empezar con el número 3`,
                        type: 'is-danger'
                    })
                }
                else{
                    if (this.nameNomenclature) this.setnameNomenclature(this.nameNomenclature)
                if (this.numberOne) this.setnumberOne(this.numberOne)
                if (this.numberTwo) this.setnumberTwo(this.numberTwo)
                if (this.numberThree) this.setnumberThree(this.numberThree)
                let address = this.nameNomenclature + ' ' + this.numberOne + ' # ' + this.numberTwo + ' - ' + this.numberThree
                this.address = address
                if (this.shippingDate) this.setShippingDate(this.shippingDate)
                if (this.state) this.setState(this.state)
                if (this.city) this.setCity(this.city)
                if (this.branch) this.setBranch(this.branch)
                if (this.scheduleRange) {
                    const scheduleRange = this.scheduleRangeData.find(scheduleRange => scheduleRange.id == this.scheduleRange)
                    this.setSchedule(scheduleRange.id)
                    this.setScheduleName(scheduleRange.range)
                }
    
                if (this.propertyType == "-Tipo de inmueble-") {
                    this.propertyType = '';
                }
                if (this.blockOrInside == "-Bloque o interior-") {
                    this.blockOrInside = '';
                }
    
                this.setpropertyType(this.propertyType)
                this.setcomplementOne(this.complementOne)
                this.setblockOrInside(this.blockOrInside)
                this.setcomplementTwo(this.complementTwo)
                if(this.phone != ""){
                    this.phone =this.phone.replace("(","").replace(")","")
                }
                if (this.address) this.setAddress(this.address)
                if (this.phone) this.setPhone(this.phone)
                if (this.cellPhone) this.setCellPhone(this.cellPhone)
                if (this.observation) this.setObservations(this.observation)
                let response = await serviceUser.prioritizedPatient(this.identification, this.identificationType)
                let patient = response.data
                if (patient && !patient.isPAC && !patient.hasPolicy && !this.contains(this.forceShippingFee, this.city)) {
                    this.shippingFee = 0
                }
                this.setShippingFee(this.shippingFee)
                this.$emit('nextStep')
                }
            }
            
            
        },

        stringToDate(_date, _format, _delimiter) {
            let formatLowerCase = _format.toLowerCase();
            let formatItems = formatLowerCase.split(_delimiter);
            let dateItems = _date.split(_delimiter);
            let monthIndex = formatItems.indexOf("mm");
            let dayIndex = formatItems.indexOf("dd");
            let yearIndex = formatItems.indexOf("yyyy");
            let month = parseInt(dateItems[monthIndex]);
            month -= 1;
            let formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
            return formatedDate;
        },

        // getAllowedDate() {
        //     let data = {
        //         date: new Date().toISOString('YYYY-MM-DD').substr(0, 10),
        //         provider: this.provider
        //     }

        //     let val = new Date().toISOString('YYYY-MM-DD').substr(0, 10)
        //     let theDate = dayjs(val)

        //     serviceCalendar
        //         .getAllowedDate(data)
        //         .then(result => {
        //             if (result.data.code.length === 0) {
        //                 let sumDate = this.sumDateWeekend(theDate.format('YYYY-MM-DD'))
        //                 serviceCalendar
        //                     .getAllowedDate({ date: sumDate.format('YYYY-MM-DD'), provider: this.provider })
        //                     .then(result => {
        //                         for (let i = 0; i < result.data.code.length; i++) {
        //                             let sumDate = sumDate.add(parseInt(result.data.code[i].daysAnswer), 'day')
        //                             let arrayFech = sumDate.format('YYYY-MM-DD').split('-')
        //                             this.fechaAllowed = new Date(arrayFech[0], arrayFech[1] - 1, arrayFech[2])
        //                             console.log('Fecha Minima: ', this.fechaAllowed)
        //                             // this.order.deliveryDate = this.fechaAllowed
        //                         }
        //                     })
        //                     .catch(erro => {
        //                         console.log(erro)
        //                     })
        //             } else {
        //                 for (let i = 0; i < result.data.code.length; i++) {
        //                     let otherFech = result.data.code[i].Date
        //                     if (otherFech === val) {
        //                         let dateDesde = this.newDate(new Date().toString().substring(16, 24).split(':'))
        //                         let dateHasta = this.newDate(result.data.code[0].closingDate.split(':'))

        //                         let minutos = (dateHasta - dateDesde) / 1000 / 60
        //                         let horas = Math.floor(minutos / 60)
        //                         minutos = minutos % 60
        //                         let total = this.prefijo(parseInt(horas)) + ':' + this.prefijo(parseInt(minutos))
        //                         let validNumber = this.validarNumber(total)
        //                         if (validNumber) {
        //                             theDate = dayjs(otherFech).add(1, 'day')
        //                             let newFech = this.callDate(theDate.format('YYYY-MM-DD'), this.provider)
        //                             console.log('alll', newFech)
        //                             if (newFech.code === undefined) {
        //                                 let sumDate = this.sumDateWeekend(theDate.format('YYYY-MM-DD'))
        //                                 let arrayFech = sumDate.format('YYYY-MM-DD').split('-')
        //                                 this.fechaAllowed = new Date(arrayFech[0], arrayFech[1] - 1, arrayFech[2])
        //                                 console.log(1, this.fechaAllowed)
        //                                 // this.order.deliveryDate = this.fechaAllowed
        //                             } else {
        //                                 // this.fechaAllowed = Date.parse(theDate.format('YYYY/MM/DD'))
        //                                 let arrayFech = theDate.format('YYYY-MM-DD').split('-')
        //                                 this.fechaAllowed = new Date(arrayFech[0], arrayFech[1] - 1, arrayFech[2])
        //                                 console.log(2, this.fechaAllowed)
        //                                 // this.order.deliveryDate = this.fechaAllowed
        //                             }
        //                         } else {
        //                             console.log('aqiu', newFech)
        //                             theDate = theDate.add(parseInt(result.data.code[i].daysAnswer), 'day')
        //                             let newFech = this.callDate(theDate.format('YYYY-MM-DD'), this.provider)
        //                             if (newFech.code === undefined) {
        //                                 let sumDate = this.sumDateWeekend(theDate.format('YYYY-MM-DD'))
        //                                 this.fechaAllowed = Date.parse(sumDate.format('YYYY/MM/DD'))
        //                                 console.log(3, this.fechaAllowed)
        //                                 // this.order.deliveryDate = this.fechaAllowed
        //                             } else {
        //                                 this.fechaAllowed = Date.parse(theDate.format('YYYY/MM/DD'))
        //                                 console.log(4, this.fechaAllowed)
        //                                 // this.order.deliveryDate = this.fechaAllowed
        //                             }
        //                         }
        //                     } else {
        //                         // Sabado
        //                         if (dayjs(theDate).day() === 6) {
        //                             this.fechaAllowed = theDate.add(2, 'day')
        //                             this.fechaAllowed = Date.parse(this.fechaAllowed.format('YYYY/MM/DD'))
        //                             console.log(5, this.fechaAllowed)
        //                             // this.order.deliveryDate = this.fechaAllowed
        //                         }
        //                         // Domingo
        //                         if (dayjs(theDate).day() === 0) {
        //                             this.fechaAllowed = theDate.add(1, 'day')
        //                             this.fechaAllowed = Date.parse(this.fechaAllowed.format('YYYY/MM/DD'))
        //                             console.log(6, this.fechaAllowed)
        //                             // this.order.deliveryDate = this.fechaAllowed
        //                         }
        //                     }
        //                 }
        //             }
        //             data = {}
        //         })
        //         .catch(erro => {
        //             console.log(erro)
        //         })
        // },

        // sumDateWeekend(date) {
        //     let sum = dayjs(date)
        //     switch (sum.day()) {
        //         case 1: // Sabado
        //             sum = sum.add(1, 'day')
        //         case 2: // Domingo
        //             sum = sum.add(1, 'day')
        //         default:
        //             // eslint-disable-next-line no-self-assign
        //             sum = sum
        //             break
        //     }
        //     return sum
        // },
        validarNumber(number) {
            return number.includes('-')
        },
        callDate(date, id) {
            let data = {
                date: date,
                provider: id
            }
            let response = []

            serviceCalendar
                .getAllowedDate(data)
                .then(result => {
                    response.push(result.data)
                })
                .catch(erro => {
                    console.log('Error: ', erro)
                })

            return response
        },

        prefijo(num) {
            return num < 10 ? ('0' + num) : num
        },

        newDate(partes) {
            let date = new Date(0)
            date.setHours(partes[0])
            date.setMinutes(partes[1])
            return date
        }
    }
};
